import { IContent } from '@_entities/content';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';

import { ContentDeletePopup } from '../../ui';

export function useContentDeletePopup(content: IContent, isContentListPage: boolean) {
	const { pushLayer } = useUILayerStore();

	function openContentDeletePopup() {
		pushLayer(
			'popup',
			<ContentDeletePopup content={content} isContentListPage={isContentListPage} />,
		);
	}

	return {
		openContentDeletePopup,
	};
}
